export default __webpack_public_path__ + "static/media/dice-img.e10b58d2.webp";